import React from "react";
import {
  Box,
  Grid,
  GridItem,
  Icon,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FaCheckCircle, FaFilePdf } from "react-icons/fa";

const API_BASE_URL = "https://api.myseraph.eu";

export default function ModelSelector({ models, selected, onSelect }) {
  return (
    <Box mb={8}>
      <Text mb={2}>1. Seleziona Modello</Text>

      <Grid templateColumns="repeat(auto-fill, minmax(140px, 1fr))" gap={2}>
        {models.map((m) => (
          <GridItem
            key={m.id}
            position="relative"
            p={4}
            color="white"
            cursor="pointer"
            bg={m.color}
            border="4px solid"
            borderColor={selected?.id === m.id ? "white.400" : "gray.100"}
            borderRadius="md"
            boxShadow={selected?.id === m.id ? "xl" : "sm"}
            ring={selected?.id === m.id ? 4 : 0}
            ringColor={selected?.id === m.id ? "teal.300" : undefined}
            ringOffset={2}
            ringOffsetColor="gray.800"
            transform={selected?.id === m.id ? "scale(1.05)" : "scale(1)"}
            transition="all 0.2s ease"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            onClick={() => onSelect(m)}
          >
            {selected?.id === m.id && (
              <Box
                position="absolute"
                top={0}
                left={0}
                w="100%"
                h="100%"
                bg="blackAlpha.600"
                borderRadius="md"
                display="flex"
                alignItems="center"
                justifyContent="center"
                zIndex={1}
              >
                <Icon as={FaCheckCircle} boxSize={8} color="teal.300" />
              </Box>
            )}

            {/* Datasheet link */}
            {m.model_datasheet && (
              <Link
                href={`${API_BASE_URL}/storage/${m.model_datasheet}`}
                isExternal
                position="absolute"
                top="8px"
                right="8px"
                zIndex={2}
              >
                <FaFilePdf size={20} />
              </Link>
            )}

            <VStack align="center" justify="center" zIndex={2}>
              {m.icon && (
                <img
                  src={`${process.env.PUBLIC_URL}/assets/${m.icon}`}
                  width="90px"
                  height="90px"
                  alt={m.title}
                />
              )}
              <Text fontSize="sm" fontWeight="bold" mb={0}>
                e-Zen
              </Text>
              <Text
                fontSize="sm"
                fontWeight="bold"
                textAlign="center"
                mt={1}
              >
                {m.title}
              </Text>
            </VStack>
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
}
